<div *ngIf="curationInProgress; else sendButton" class="pending-container">
  <i class="icon icon__dls-refresh-grey pending-icon "></i>
  <span class="action-layout" translate>aberration.pending_curation</span>
</div>
<ng-template #sendButton>
  <gen-button class="action-layout" [type]="'quite'" (click)="curationRequest($event)" [text]="'aberration.' + (wasCuratedBefore ? 'update' : 'curate') | translate"></gen-button>
</ng-template>
